// Notification API key service
// This should return your notification API key
// Replace with your actual API key logic
export const getApiKey = async () => {
  // This might come from your backend, local storage, or environment variables
  return '5873560302B74711BDC82EC91CED82B6';
};
